export enum CDNAsset {
  PartyIcons = "vendor-icons",
  OrganizationIcons = "org-icons",
}

const AssetsHelper = {
  publicUrl(assetPath: CDNAsset, objectName: string) {
    if (!objectName?.length) return undefined

    const assetsUrl = process.env.PUBLIC_ASSETS_URL
    if (!assetsUrl) {
      TrackJS?.console.error("Missing public assets url in the environment")
      return undefined
    }

    return [assetsUrl, assetPath, objectName].join("/")
  },

  // Requires a valid public asset URL (e.g. created via the above helper)
  objectName(publicUrl: string | undefined): string | undefined {
    const assetsUrl = process.env.PUBLIC_ASSETS_URL

    if (!assetsUrl || !publicUrl || !publicUrl.startsWith(assetsUrl)) {
      return undefined
    }

    return publicUrl.split("/").pop()
  },
}

export default AssetsHelper
